import '@mantine/core/styles.css';
import './estilos/marca.css';

import { MantineProvider, createTheme } from '@mantine/core';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import { App } from './app/App';

// Cores do tema do legado (.streamlit/config.toml).
const tema = createTheme({
  primaryColor: 'persevera',
  colors: {
    persevera: [
      '#e8eef7',
      '#c9d6ea',
      '#a6bcdc',
      '#7f9fcc',
      '#5b84bd',
      '#3e6aa6',
      '#2c5185',
      '#1f3c66',
      '#0d2340',
      '#081629',
    ],
    // Dourado da marca (logo, gráficos e imagem do Hora 360).
    dourado: [
      '#f8f4ee',
      '#ece2d3',
      '#dfcfb6',
      '#d2bc99',
      '#c6aa80',
      '#b99b7b',
      '#a3845f',
      '#86694a',
      '#6a5239',
      '#4e3c29',
    ],
  },
  primaryShade: 8,
  fontFamily: 'Roboto, system-ui, sans-serif',
});

const clienteQuery = new QueryClient({
  defaultOptions: {
    queries: {
      // Alinhado ao TTL do cache do backend (1 h para séries): evita refetch à toa.
      staleTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MantineProvider theme={tema}>
      <QueryClientProvider client={clienteQuery}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </MantineProvider>
  </StrictMode>,
);
